import FnrFetch3, { callMockResponse } from "Utilities/FnrFetch/FnrFetch3";
import { fnThrowError } from "Utilities/fnReportError";

import { mockData } from "../mockData";

export const getDashboardCards = async () => {
  const endpoint = "/gettingStartedCards/cards";
  const fetchFunction = mockData.shouldMock
    ? callMockResponse(mockData.getDashboardCards)
    : new FnrFetch3(endpoint);

  const response = await fetchFunction.get().catch((err) =>
    //   Throwing in an async function will convert the Error to a failed promise. react-query will then give you the result in an error state (isError: true and state === 'error').
    //   You can see that in action here: https://codesandbox.io/s/nostalgic-feynman-wrm60
    //   Please note that react-query retries queries per default (3 times, with an exponential backoff).
    //   So you will not "immediately" see the error(it takes a couple of seconds in the example).You can customize this in the query options: https://react-query.tanstack.com/docs/guides/query-retries
    //   throw new Error(`Error at ${endpoint}: ${err}`);
    fnThrowError({
      message: `Error at ${endpoint}: ${err}`,
    })
  );

  return response;
};

export const dismissDashboardCard = async (cardID) => {
  const endpoint = "/gettingStartedCards/dismiss/userCard";
  const fetchFunction = mockData.shouldMock
    ? callMockResponse(mockData.dismissDashboardCard)
    : new FnrFetch3(endpoint, { cardID });
  // Throw an error after 2 seconds, Leave for demo then remove
  // await new Promise((resolve, reject) => {
  //   setTimeout(() => {
  //     reject(new Error("Test error after 2 seconds"));
  //   }, 2000);
  // });

  const response = await fetchFunction.post().catch((err) =>
    fnThrowError({
      message: `Error at ${endpoint}: ${err}`,
    })
  );

  return response;
};

export const getSideLinks = async () => {
  const endpoint = "/gettingStartedCards/sideLinks";
  const fetchFunction = mockData.shouldMock
    ? callMockResponse(mockData.getSideLinks)
    : new FnrFetch3(endpoint);

  const response = await fetchFunction.get().catch((err) =>
    fnThrowError({
      message: `Error at ${endpoint}: ${err}`,
    })
  );

  return response;
};
